import { render, staticRenderFns } from "./AverageTicketCmp.vue?vue&type=template&id=0adc9a12&"
import script from "./AverageTicketCmp.vue?vue&type=script&lang=js&"
export * from "./AverageTicketCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports